import styled from 'styled-components';
export const DropdownWrapper = styled.div `
  overflow: hidden;
  display: flex;
  flex-flow: column;
`;
export const HeaderWrapper = styled.div `
  height: 68px;
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
export const OptionsWrapper = styled.div `
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  isolation: isolate;
  overflow-y: auto;
  overflow-x: hidden;

  background: ${({ theme }) => theme.colors.grey00_6};
`;
export const DropdownBody = styled.div `
  ${({ theme }) => theme.typography.textMedium};
  display: flex;
  height: 172px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  isolation: isolate;
`;
export const FooterWrapper = styled.div `
  ${({ theme }) => theme.typography.textSmall};
  color: ${({ theme }) => theme.colors.grey100_1};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  gap: 10px;
  overflow: hidden;
  width: ${({ width }) => width}px;
  height: 40px;
  background: ${({ theme }) => theme.colors.grey00_6};
  border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
export const GroupHeaderWrapper = styled.div `
  ${({ theme }) => theme.typography.textSmall}
  ${({ theme }) => theme.typography.weightMedium}
  width: 100%;
  padding-left: 16px;
  padding-bottom: 1px;
  color: ${({ theme }) => theme.colors.grey100_1};
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey10_1};
`;
